export default __webpack_public_path__ + "static/media/Explore.ce739f1d.mp3";